import {
  MdbaseBrowserSelection,
  MdbaseConnect,
} from "@mdbase-dev/connect";

export {
  connectErrorMessage,
  connectProblemError,
  connectProblemMessage,
} from "./connect-outcomes";

const environment = import.meta.env;
const appRoot = new URL("/", location.href);
const manifest = new URL(".well-known/mdbase-app.json", appRoot);

export const connect = new MdbaseConnect({
  serverUrl: String(
    environment.VITE_MDBASE_CONNECT_URL || "https://connect.mdbase.dev",
  ),
  manifest: manifest.href,
  redirectUri: appRoot.href,
});

export const session = connect.application({
  selection: new MdbaseBrowserSelection({ fallbackPath: "/" }),
  autoSelect: "only",
});

export const isDemoMode = environment.VITE_DEMO_MODE === "1";
